<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="innerValue"
        v-bind="$attrs"
        v-on="on"
        :rules="rules"
        readonly
        prepend-inner-icon="mdi-calendar-range"
        @click:append="menu = true"
      >
        <slot></slot>
        <template #prepend-inner>
          <img src="@/assets/icons/ant-design_calendar-outlined.svg" />
        </template>
      </v-text-field>
    </template>
    <!-- TODO: no need to bind all attrs to both field -->
    <v-date-picker
      v-model="innerValue"
      no-title
      v-bind="$attrs"
    ></v-date-picker>
  </v-menu>
</template>

<script>
// import VTextInput from "./VTextInput";

export default {
  name: "DateField",
  components: {
    // TextField: VTextInput
  },
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    // must be included in props
    value: {
      type: null
    }
  },
  data: () => ({
    menu: false,
    innerValue: "",
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.menu = false;
      this.$emit("input", newVal);
      this.$emit("change", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal || "";
    }

    // TODO: Birthday picker
    // menu(val) {
    //   val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    // }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
